import {
    Button,
    Row,
    Form,
    Input,
    Space,
    Table,
    Col,
    Empty,
    ConfigProvider,
    Select,
    Tooltip,
} from "antd";
import {observer} from "mobx-react-lite";
import {useEffect, Fragment} from "react";
import "./index.css";
import {XPoolStore} from "../../../../store";
import dictionary from "../../../../utils/dictionary";
import {InfoCircleOutlined} from "@ant-design/icons";

const {Column} = Table;

function PoolXAllocation(props: any) {
    const [form] = Form.useForm();
    const {Option} = Select;

    useEffect(() => {
        form.setFieldsValue({name: ""});
        resetSearchbth();
        // CommonStore.getPagePermission("apool_management");
    }, []);
    const getFormData = (
        changeValue: powerSearchData,
        allValues: powerSearchData
    ) => {
        XPoolStore.setSearchForm({...allValues});
    };

    const searchBtn = () => {
        XPoolStore.resetPage();
        XPoolStore.manageXPoolPage();
    };
    const resetSearchbth = () => {
        XPoolStore.setSearchForm({});
        searchBtn();
    };

    const tableEmptyRender = () => {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<>暂无数据</>}
            ></Empty>
        );
    };

    return (
        <Fragment>
            <div className="formContent">
                <Form
                    form={form}
                    initialValues={XPoolStore.searchForm}
                    autoComplete="off"
                    labelCol={{span: 6}}
                    onValuesChange={getFormData}
                >
                    <Row justify="start">
                        <Col span={8}>
                            <Form.Item label="编号" name="no">
                                <Input placeholder="请输入编号"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="号池名称"
                                name="name"
                            >
                                <Input placeholder="请输入号池名称"/>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="号池状态"
                                name="poolStatus"
                            >
                                <Select placeholder="请选择号池状态">
                                    {Object.keys(dictionary.poolStatus).map((key) => (
                                        <Option key={key} value={key}>
                                            {dictionary.poolStatus[key]}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col><Col offset={2}>
                            <Form.Item>
                                <Space>
                                    <Button type="primary" onClick={searchBtn}>
                                        搜索
                                    </Button>
                                    <Button htmlType="reset" onClick={resetSearchbth}>
                                        重置
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <ConfigProvider renderEmpty={tableEmptyRender}>
                <Table
                    dataSource={XPoolStore.tableData.records}
                    rowKey={(record: { no: string }) => record.no}
                    loading={XPoolStore.tableLoad}
                    scroll={{x: 1200}}
                    pagination={{
                        current: XPoolStore.pageData.page,
                        pageSize: XPoolStore.pageData.size,
                        onChange: XPoolStore.pageData.changePage,
                        pageSizeOptions: [10, 25, 50],
                        showSizeChanger: true,
                        total: XPoolStore.tableData.total,
                        showTotal: () => `共计${XPoolStore.tableData.total}条`,
                        position: ["bottomLeft"],
                    }}
                >
                    <Column ellipsis={true} width={120} title="编号" dataIndex="no" render={(no) => (
                        <Tooltip placement="topLeft" title={no}>
                            <InfoCircleOutlined/>
                        </Tooltip>
                    )}/>
                    <Column
                        ellipsis={true}
                        width={150}
                        title="号池名称"
                        dataIndex="name"
                    />
                    <Column
                        title="号池状态"
                        width={150}
                        ellipsis={true}
                        dataIndex="poolStatus"
                        render={(poolStatus) => dictionary.poolStatus[poolStatus]}
                    />
                    <Column
                        title="起呼A池"
                        width={150}
                        ellipsis={true}
                        dataIndex="callInitializerNumberPool"
                    />
                    <Column
                        title="平台编码"
                        width={150}
                        dataIndex="targetPlatformId"
                        ellipsis={true}
                    />
                </Table>
            </ConfigProvider>
        </Fragment>
    );
}

export default observer(PoolXAllocation);
